import React from 'react';
import PropTypes from 'prop-types';

import styles from './preloader.module.css';

const Preloader = ({ active }) =>
  (active ? (
    <div className={styles.preloader}>
      <span className="icon--spinner icon-spin" />
    </div>
  ) : null);

Preloader.propTypes = {
  active: PropTypes.bool
};

Preloader.defaultProps = {
  active: false
};

export default Preloader;
